<template>
    <div :id="this.$route.name">
        <card back add>
            <template v-slot:header>
                <h4 class="d-inline">لـیست مجوزات</h4>
                <hr />
            </template>
            <template v-slot:content>
                <div class="row">
                    <div class="col-lg-6 col-12 mt-3">
                        <small id="LblTblCostomer">مربوط به مشتری</small>
                        <SearchableCombo :edit="false" :grp="0" :code="null" @ResultCombo="GetResulTblCostomer"
                            :rownumintable="3" :action="'TblCrmCombo/GetCostomerProduct'" :method="'POST'"
                            :idinput="'TblCostomer'" :keyItem="'TblCostomer'" :disabled="false"
                            :ClassProps="'required'">
                        </SearchableCombo>
                    </div>
                </div>

                <div>
                    <BnpGrid Selectable :action="true" :propsRows="customerLicense" :propsColumn="propsColumn"
                        :NoRowNum="true" v-if="render">

                        <template slot="LicenseFile" slot-scope="props">
                            <h5 class="fad fa-download text-warning" @click="downloadLicense(props.props)">

                            </h5>
                        </template>

                        <template slot="action-slot" slot-scope="props">
                            <div>
                                <a href="javascript:;" class="badge text-center" @click="removeLicense(props.props)">
                                    <h6><span class="fa fa-times hover-danger"></span></h6>
                                </a>
                            </div>
                        </template>

                    </BnpGrid>
                </div>

            </template>
        </card>
    </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'

export default {
    components: { Card, SearchableCombo, BnpGrid },
    data() {
        return {
            customerLicense: [],

            propsColumn: [
                { name: 'Name', label: 'نام محصولات', visibility: true },
                { name: 'DeviceIdentifier', label: 'شناساه یکتا', visibility: true },
                { name: 'EndDate', label: 'تاریخ پایان', visibility: true },
                { name: 'Online', label: 'Online', visibility: true },
                { name: 'LicenseFile', label: 'فایل لایسنس', visibility: true },

            ],
            render: true,
            lastDataCombo: []
        }
    },

    mounted() {

    },


    methods: {
        GetResulTblCostomer(data) {
            if (data.id != null) {
                this.lastDataCombo = data
                let axios = {
                    Method: 'get',
                    Action: 'license/GetCustomerLicense/' + data.id,
                }
                this.$PostData(axios)
                    .then((data) => {
                        this.customerLicense = []

                        data.forEach(element => {

                            var newItem = {
                                Name: ''
                            }
                            element.forEach(el2 => {
                                newItem.Name += el2.name + ','
                                newItem.DeviceIdentifier = el2.deviceIdentifier,
                                    newItem.EndDate = el2.endDate,
                                    newItem.Online = el2.online,
                                    newItem.LicensePath = el2.licensePath,
                                    newItem.Id = el2.tblLicenseId
                            })
                            newItem.Name = newItem.Name.substring(0, newItem.Name.length - 1)
                            this.customerLicense.push(newItem)
                        });
                        this.render = false
                        this.$nextTick(() => {
                            this.render = true
                        })


                    }).catch((err) => {
                        console.error("CATCH", err);
                    })
            }
        },
        getCustomerLicense() {

        },
        removeLicense(item) {
            this.$store.state.OldDataForLog = JSON.stringify(item)
            const swalWithBootstrapButtons = this.$swal.mixin({
                customClass: {
                    confirmButton: 'btn btn-success mx-1',
                    cancelButton: 'btn btn-danger',
                },
                buttonsStyling: false,
            })
            swalWithBootstrapButtons
                .fire({
                    title: 'اطمینان دارید؟',
                    text: 'از حذف ' + '؟',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'بله، حذف شود',
                    cancelButtonText: 'لغو',
                    reverseButtons: true,
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        let axios = {
                            Method: 'delete',
                            Action: 'license/DeleteLicense/' + item.Id,
                        }
                        this.$PostData(axios).then((res) => {
                            if (res.isSuccess == true) {
                                this.$toasted.success('حذف با موفقیت صورت گرفت', {
                                    action: {
                                        text: 'بستن',
                                        onClick: (e, toastObject) => {
                                            toastObject.goAway(0)
                                        },
                                    },
                                })

                                this.GetResulTblCostomer(this.lastDataCombo)
                                this.$SetLog(item, 1)
                            } else {
                                this.$toasted.error('خطایی رخ داد', {
                                    action: {
                                        text: 'بستن',
                                        onClick: (e, toastObject) => {
                                            toastObject.goAway(0)
                                        },
                                    },
                                })
                            }
                        }).catch((err) => {
                            console.error("CATCH", err);
                            swalWithBootstrapButtons.fire('', 'عملیات با خطا مواجه شد', 'error')
                        })
                    }

                })


        },
        downloadLicense(item) {
            let axios = {
                Method: 'get',
                Action: 'license/DownloadLicense/' + item.Id,
            }
            this.$PostData(axios).then((res) => {
                if (res.isSuccess) {
                    var fileLink = document.createElement('a')
                    fileLink.href = 'data:application/octet-stream;base64,' + res.file
                    fileLink.setAttribute('download', res.fileName)
                    document.body.appendChild(fileLink)
                    fileLink.click()
                } else {
                    this.$toasted.error(res.mseesage, {
                        action: {
                            text: 'بستن',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0)
                            },
                        },
                    })
                }
            }).catch((err) => {
                this.$toasted.error('خطایی رخ داد', {
                    action: {
                        text: 'بستن',
                        onClick: (e, toastObject) => {
                            toastObject.goAway(0)
                        },
                    },
                })
                console.error("CATCH", err);
            })
        }
    }
}
</script>
<style scoped>

</style>